import { QuestionPlanMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target";

import { useDayTripPlanI18nMainTarget } from "./hooks";

export const QuestionMainTarget = () => {
	const { mainTarget, onSetMainTarget } = useDayTripPlanI18nMainTarget();

	return <QuestionPlanMainTarget mainTarget={mainTarget} onSetMainTarget={onSetMainTarget} />;
};

QuestionMainTarget.displayName = "QuestionMainTarget";
